"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
exports.extractAirlineFilterData = extractAirlineFilterData;
exports.extractAirportFilterData = extractAirportFilterData;
exports.extractFiltersData = extractFiltersData;
exports.extractPriceFilterData = extractPriceFilterData;
exports.extractStopFilterData = extractStopFilterData;
exports.extractTimeFilterData = extractTimeFilterData;
var _concat2 = _interopRequireDefault(require("lodash/concat"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _intersection2 = _interopRequireDefault(require("lodash/intersection"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _max2 = _interopRequireDefault(require("lodash/max"));
var _min2 = _interopRequireDefault(require("lodash/min"));
var _split3 = _interopRequireDefault(require("lodash/split"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _zipWith2 = _interopRequireDefault(require("lodash/zipWith"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _constants = require("../constants");
function extractFiltersData(flightsFilterParams, filterKeys) {
  if (filterKeys === void 0) {
    filterKeys = _constants.DEFAULT_FILTER_KEYS;
  }
  var filtersData = {};
  if ((0, _isEmpty2.default)(flightsFilterParams)) {
    return filtersData;
  }
  (0, _each2.default)(filterKeys, function (filterKey) {
    switch (filterKey) {
      case 'airline':
        filtersData.airline = extractAirlineFilterData((0, _map2.default)(flightsFilterParams, 'airline'));
        break;
      case 'airport':
        filtersData.airport = extractAirportFilterData((0, _map2.default)(flightsFilterParams, 'airport'));
        break;
      case 'price':
        filtersData.price = extractPriceFilterData((0, _map2.default)(flightsFilterParams, 'price'));
        break;
      case 'stop':
        filtersData.stop = extractStopFilterData((0, _map2.default)(flightsFilterParams, 'stop'));
        break;
      case 'maxStop':
        filtersData.maxStop = extractStopFilterData((0, _map2.default)(flightsFilterParams, 'maxStop'));
        break;
      case 'departureTime':
        filtersData.departureTime = extractTimeFilterData((0, _map2.default)(flightsFilterParams, 'departureTime'));
        break;
      case 'arrivalTime':
        filtersData.arrivalTime = extractTimeFilterData((0, _map2.default)(flightsFilterParams, 'arrivalTime'));
        break;
      case 'insuranceOnly':
        filtersData.insuranceOnly = flightsFilterParams.insuranceOnly;
        break;
      case 'hasBaggageOnly':
        filtersData.hasBaggageOnly = (0, _some2.default)(flightsFilterParams, {
          hasBaggageOnly: true
        });
        break;
      case 'isFlex':
        filtersData.isFlex = (0, _some2.default)(flightsFilterParams, {
          isFlexFlight: true
        });
        break;
      default:
        break;
    }
  });
  return filtersData;
}
function extractAirlineFilterData(filterValues) {
  var allValues = _concat2.default.apply(void 0, filterValues);
  var topAirlinesValues = (0, _intersection2.default)(_constants.TOP_AIRLINES, allValues);
  return (0, _uniq2.default)((0, _concat2.default)(topAirlinesValues, allValues));
}
function extractAirportFilterData(filterValues) {
  return _zipWith2.default.apply(void 0, filterValues.concat([function () {
    var origin = [];
    var destination = [];
    for (var _len = arguments.length, routes = new Array(_len), _key = 0; _key < _len; _key++) {
      routes[_key] = arguments[_key];
    }
    (0, _each2.default)(routes, function (route) {
      var _split2 = (0, _split3.default)(route, _constants.FILTER_PARAM_AIRPORT_SEPARATOR),
        originId = _split2[0],
        destinationId = _split2[1];
      originId && !origin.includes(originId) && origin.push(originId);
      destinationId && !destination.includes(destinationId) && destination.push(destinationId);
    });
    return {
      origin: origin,
      destination: destination
    };
  }]));
}
function extractPriceFilterData(filterValues) {
  return {
    min: (0, _min2.default)(filterValues),
    max: (0, _max2.default)(filterValues)
  };
}
function extractStopFilterData(filterValues) {
  return (0, _uniq2.default)(filterValues).sort();
}
function extractTimeFilterData(filterValues) {
  return {
    legCount: (0, _max2.default)((0, _map2.default)(filterValues, function (legFilterValues) {
      return (0, _get2.default)(legFilterValues, 'length', 0);
    }))
  };
}
var _default = exports.default = extractFiltersData;